/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ResourcesInputs */

const en_nav_resources = /** @type {(inputs: Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const de_nav_resources = /** @type {(inputs: Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcen`)
};

const fr_nav_resources = /** @type {(inputs: Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressources`)
};

const es_nav_resources = /** @type {(inputs: Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos`)
};

const it_nav_resources = /** @type {(inputs: Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risorse`)
};

const nl_nav_resources = /** @type {(inputs: Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronnen`)
};

const pl_nav_resources = /** @type {(inputs: Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zasoby`)
};

const fi_nav_resources = /** @type {(inputs: Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resurssit`)
};

const da_nav_resources = /** @type {(inputs: Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcer`)
};

const sv_nav_resources = /** @type {(inputs: Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resurser`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Nav_ResourcesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_resources = /** @type {((inputs?: Nav_ResourcesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ResourcesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_resources(inputs)
	if (locale === "fr") return fr_nav_resources(inputs)
	if (locale === "es") return es_nav_resources(inputs)
	if (locale === "it") return it_nav_resources(inputs)
	if (locale === "nl") return nl_nav_resources(inputs)
	if (locale === "pl") return pl_nav_resources(inputs)
	if (locale === "fi") return fi_nav_resources(inputs)
	if (locale === "da") return da_nav_resources(inputs)
	if (locale === "sv") return sv_nav_resources(inputs)
	return en_nav_resources(inputs)
});